import join from 'url-join';
import { ArticleFragmentResponse } from '../../../../fragments/article';
import useSiteMetadata from '../../../Seo/useSiteMetadata';

export const BREADCRUMB_HASH = '#breadcrumb';

const useBreadcrumbListObject = (article: ArticleFragmentResponse) => {
  const { siteUrl } = useSiteMetadata();

  const { slug, title, category } = article;
  const { universe } = category || {};
  const { parent_universe } = universe || {};

  const createBreadcrumb = (position: number, pathname?: string, name?: string) => {
    if (!pathname || !name) {
      return undefined;
    }

    const href = join(siteUrl, pathname);
    return {
      position,
      '@type': 'ListItem',
      item: {
        name,
        '@type': 'WebPage',
        '@id': href,
        url: href,
      },
    };
  };

  const titles = [
    [parent_universe?.root_page?.slug?.current, parent_universe?.title],
    [universe?.root_page?.slug?.current, universe?.title],
    [category?.slug?.current, category?.title],
    [slug?.current, title],
  ] as const;

  const elements = titles
    .filter(([pathname, name]) => !!pathname && !!name)
    .map(([pathname, name], index) => createBreadcrumb(index + 1, pathname, name));

  if (slug?.current && elements?.length) {
    return {
      '@type': 'BreadcrumbList',
      '@id': join(siteUrl, slug?.current, BREADCRUMB_HASH),
      itemListElement: elements,
    };
  }
};

export default useBreadcrumbListObject;
